import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NotificationService } from 'src/app/shared/services/notification-service';
import { LocalStorageService } from '../../../shared/services/local-storage.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { LoggedInUserDto } from '../../interfaces/loggedInUserDto';

@Injectable()
// tslint:disable-next-line: class-name
export class httpInterceptor implements HttpInterceptor {
  azureBasicTokenUrl = ['Azure/AzureKeys'];
  identityBasicTokenUrls = ['LabPortAuth/Login',
    'LabPortAuth/SendOtp', 'LabPortAuth/ForgotPassword', 'Announcement/GetAnnouncementsForLogonPage',
    'BrowserDetails/GetBrowserDetails', 'AoeRegistration/GetQuestionsByTestCodes', 'MasterData', 'Patient/GetInsurancePayors',
    'Patient/GetStateList', 'Event/GetEventCodeByAccessCode/',
    'EnumOrder',
    'Content/LabPort/ContactSupport', 'Content/LabPort/TermsOfUse', 'Content/LabPort/PrivacyPolicy', 'Content/LabPort/OrderingPhysicianSignature', 'Email/ContactSupport',
    'LabPortAuth/SendLoginMfaOtp','LabPortAuth/VerifyMfaCode', 'Patient/GetInsurancePayorsByInputDetails', 'Content/LabPort/ExternalLink','Content/LabPort/EurofinsSupport', 'Content/LabPort/EurofinsSupportForBulkExport'];
  textResponseType = ['Content/LabPort/ContactSupport', 'Content/LabPort/TermsOfUse', 'Content/LabPort/PrivacyPolicy', 'Content/LabPort/OrderingPhysicianSignature', 'Content/LabPort/ExternalLink', 'Content/LabPort/EurofinsSupport', 'Content/LabPort/EurofinsSupportForBulkExport'];
  blobResponseType = ['Report/DownloadReport', 'BulkUpload/DownloadBulkUploadTemplate', 'Test/DownloadTestInstruction',
    'CommercialOrder/Download/PurchaseOrders', 'CommercialOrder/Download/CommercialOrders', 'OrderResult/Download/OrderResults',
    'Patient/Download/Patients', 'Test/DownloadParameterUploadTemplate', 'Report/MergeMultipleReportsAndDownload',
    'PackageOrder/ExportPackageManifest/', 'PackageOrder/ExportRequisitionManifest/', 'CommercialOrder/ExportLmnAsPdf'];
  noAtiontype = ['BulkUpload/ValidateAndUploadBulkPatients', 'Test/ValidateParameters','BulkUpload/ValidateAndUploadBulkOrders'];
  appId = 'labport';
  tokenExpiryInMin = 90;

  excapeSnackBarMsg = [
    'LabPortAuth/SendOtp',
    'LabPortAuth/Login'
  ];
  exceptUrlForLoad = ['Authorization', 'EnumUser/Permission', 'Content/GetPolicyAcceptanceDetail', 'LabPortAuth/SetPassword'];
  ipAddress:any;
  constructor(
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    private router: Router,
    private localStorage: LocalStorageService,
    private http: HttpClient
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authInfo = this.authenticationService.GetAuthInfo();
    const isAuthenticated = this.authenticationService.IsAuthenticated();
    const loggedUserDetails = this.authenticationService.GetLoggedInUserDetails();

    if (authInfo?.accessToken) {
      request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + authInfo.accessToken) });
      request = request.clone({ headers: request.headers.set('SessionKey', authInfo.sessionKey) });
      if (!this.exceptUrlForLoad.some( i => request.url.includes(i)) && !isAuthenticated) {
        this.authenticationService.ClearData();
      }
    }

    if (this.identityBasicTokenUrls.some(i => request.url.includes(i))) {
      if (!this.authenticationService.GetBasicAuthToken()) {
        this.authenticationService.SetNGetBasicTokenFromSession((data) => {
          const encodedToken = this.constructToken(request, data);
          request = request.clone({ headers: request.headers.set('Authorization', 'Basic ' + encodedToken) });
        });
      } else {
        const encodedToken = this.constructToken(request, this.authenticationService.GetBasicAuthToken());
        request = request.clone({ headers: request.headers.set('Authorization', 'Basic ' + encodedToken) });
      }
    }

    if (this.azureBasicTokenUrl.some(i => request.url.includes(i))) {
      const encodedToken = this.constructToken(request, this.authenticationService.GetAzureBasicAuthToken());
      request = request.clone({ headers: request.headers.set('Authorization', 'Basic ' + encodedToken) });
    }

    if (this.textResponseType.some(t => request.url.includes(t))) {
      request = request.clone({ responseType: 'text' });
    }
    if (this.blobResponseType.some(b => request.url.includes(b))) {
      request = request.clone({ responseType: 'blob' });
    } else if (this.noAtiontype.some(n => request.url.includes(n))) {
      request = request.clone();
    } else {
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
      request = request.clone({ headers: request.headers.set('Cache-Control', 'no-cache') });
      request = request.clone({ headers: request.headers.set('Pragma', 'no-cache') });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => this.handleHttpError(error, isAuthenticated, loggedUserDetails, request))
    );
  }

  private OnErrorZeroOr500(error: HttpErrorResponse, isAuthenticated: boolean, loggedUserDetails: LoggedInUserDto) {
    if ((error.error)?.ExceptionDetails) {
      if (isAuthenticated) {
        (error.error).ExceptionDetails.User = loggedUserDetails.email;
      }
      this.localStorage.setItem('Service-Error', JSON.stringify((error.error).ExceptionDetails));
    }
    this.router.navigate(['/error-page']);
  }

  private handleHttpError(error: HttpErrorResponse, isAuthenticated: boolean, loggedUserDetails: LoggedInUserDto, request: HttpRequest<any>): Observable<never> {
    if (error instanceof HttpErrorResponse) {
      switch (error.status) {
        case 400: {
          const error400: any = error.error;
          this.handle400Error(error400);
          break;
        }
        case 422:
          if (error.statusText && !(this.excapeSnackBarMsg.some(t => request.url.includes(t)))) {
            this.notificationService.warn(error.statusText);
          }
          break;
        case 500:
        case 0:
          this.OnErrorZeroOr500(error, isAuthenticated, loggedUserDetails);
          break;
      }
    }
    return throwError(() => error);
  }

  private handle400Error(error400: any): void {
    if (error400.errors) {
      let message = '';
      for (const key in error400.errors) {
        if (key) {
          message += (message === '') ? error400.errors[key][0] : ',' + error400.errors[key][0];
        }
      }
      if (message) { this.notificationService.warn(message); }
    }
  }

  private constructToken(request: HttpRequest<any>, basicToken: string) {
    let pathname = null;
    if (typeof URL !== 'function') {
      const value = request.url.replace(/^[^:]*:\/*/, '');
      const pathnameMatch = /\/([^?#]*)/.exec(value);
      pathname = pathnameMatch ? pathnameMatch[0] : '';
    } else {
      pathname = new URL(request.url).pathname;
    }
    const epochTimeinSeconds = Math.floor(new Date().getTime() / 1000.0);
    const tokenExpiryTime = epochTimeinSeconds + (this.tokenExpiryInMin * 60);
    const payload = `${this.appId}:${basicToken}:${tokenExpiryTime}:${request.method}:${pathname}`;
    const encodedPayload = btoa(payload);
    return encodedPayload;
  }
} 
